import React from 'react';
import { t, props } from 'tcomb-react';
import stripeCheckoutButton from '../util/stripeCheckoutButton';

@props({
  stripe_sca: t.Any,
  children: t.Any
})
export default class PurchaseStripeScaGateway extends React.Component {

  /*componentDidMount() {
    $('#stripeScaGatway').html('<button id="checkout-button" onClick={this.onClickPayment} className="stripe-button"><span>Pay with Carddddddddddddd</span></button>');    
  }
*/
  onClickPayment = () => {
    let stripe_sca = this.props.stripe_sca
    stripeCheckoutButton(stripe_sca.sessionId, stripe_sca.publicKey)
  }

  render() {
    return (
      <div>
        <div id="stripeScaGatway">
          <button id="checkout-button-sca" onClick={this.onClickPayment.bind(this)} /*className="stripe-button-el"*/ style={{fontSize: '13px'}}><span>Pay with Card</span></button>
        </div>
        <div>
          {this.props.children}
        </div>
        <hr/>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/PurchaseStripeScaGateway.js
 **/